var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Container',{nativeOn:{"!click":function($event){return _vm.interceptMakeClick.apply(null, arguments)}}},[_c('CardSection',{attrs:{"title":_vm.title,"data-external":"makes-carousel","mobile":{ cardMode: 'scroll', cardSpacing: '16px', cardFlexBasis: 'calc(100%/2)' },"tablet":{
      cardMode: 'scroll',
      cardSpacing: '16px',
      cardFlexBasis: 'calc(100%/3)',
      showSteppers: true,
    },"desktop":{
      cardMode: 'scroll',
      cardSpacing: '16px',
      cardFlexBasis: 'calc(100%/4)',
      showSteppers: true,
    }}},[_vm._l((_vm.makes),function(make){return [(make.content.banner_image)?_c('BrandCard',{key:make.uuid,attrs:{"link":_vm.getMakeUrl(make.slug),"image-src":make.content.banner_image.filename,"image-alt":make.content.title,"data-make-slug":make.slug,"data-make-title":make.content.title,"data-make-logo":make.content.banner_image.filename}}):_c('BrandCard',{key:make.uuid,attrs:{"link":_vm.getMakeUrl(make.slug),"data-make-slug":make.slug,"data-make-title":make.content.title}},[_c('div',{staticClass:"makes-carousel-card"},[_vm._v(_vm._s(make.content.title))])])]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }